import base64 from 'base-64'
import utf8 from 'utf8'

const encode = value => base64.encode(utf8.encode(value))
const decode = value => utf8.decode(base64.decode(value))

const key = encode('mpInterfacePreference-v2')

const getLocalStorageData = () => {
  const preferenceList = localStorage.getItem(key)

  if (preferenceList) {
    return JSON.parse(decode(preferenceList))
  } else {
    return {}
  }
}

/**
 * @param {number} mode
 * @returns {number}
 */
export const getInterfacePreference = (mode) => {
  const preferenceList = getLocalStorageData()
  const regionMode = preferenceList[mode] || 0

  return parseInt(regionMode)
}

/**
 * @param {number} mode
 * @param {number} mode
 * @returns {number}
 */
export const setInterfacePreference = (region, mode) => {
  const preferenceList = getLocalStorageData()
  preferenceList[region] = mode

  localStorage.setItem(key, encode(JSON.stringify(preferenceList)))

  return preferenceList
}

export default {
  getInterfacePreference,
  setInterfacePreference,
}